(function () {
  const desktopMedia = window.matchMedia('(min-width: 720px)')
  const observers = new WeakMap()

  /**
   * 根据左右列真实高度，只让较矮的一列保持粘性。
   * 折叠内容展开或图片高度变化后会自动重新计算。
   */
  function updateStickyColumn(wrapper) {
    const leftColumn = wrapper.querySelector('[data-product-visual-column]')
    const rightColumn = wrapper.querySelector('[data-product-main-column]')
    if (!leftColumn || !rightColumn) return

    leftColumn.classList.remove('product--column-sticky')
    rightColumn.classList.remove('product--column-sticky')

    if (!desktopMedia.matches) return

    // Header 开启粘性时，为产品列预留 Header 高度和额外间距，避免内容被遮挡。
    const stickyHeader = document.body.classList.contains('site-header-sticky')
      ? document.querySelector('.site-header')
      : null
    const stickyTop = (stickyHeader ? stickyHeader.getBoundingClientRect().height : 0) + 24
    wrapper.style.setProperty('--product-sticky-top', `${Math.ceil(stickyTop)}px`)

    const leftHeight = leftColumn.getBoundingClientRect().height
    const rightHeight = rightColumn.getBoundingClientRect().height
    const shorterColumn = leftHeight <= rightHeight ? leftColumn : rightColumn
    shorterColumn.classList.add('product--column-sticky')
  }

  /**
   * 合并短时间内的多次尺寸变化，避免重复触发布局计算。
   */
  function scheduleUpdate(wrapper) {
    if (wrapper.dataset.stickyUpdatePending === 'true') return
    wrapper.dataset.stickyUpdatePending = 'true'
    window.requestAnimationFrame(function () {
      wrapper.dataset.stickyUpdatePending = 'false'
      updateStickyColumn(wrapper)
    })
  }

  function initAdaptiveSticky(scope) {
    const wrappers = scope.matches && scope.matches('[data-adaptive-product]')
      ? [scope]
      : scope.querySelectorAll('[data-adaptive-product]')

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.adaptiveStickyReady === 'true') {
        scheduleUpdate(wrapper)
        return
      }

      wrapper.dataset.adaptiveStickyReady = 'true'
      wrapper.addEventListener('toggle', function () {
        scheduleUpdate(wrapper)
      }, true)

      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(function () {
          scheduleUpdate(wrapper)
        })
        const leftColumn = wrapper.querySelector('[data-product-visual-column]')
        const rightColumn = wrapper.querySelector('[data-product-main-column]')
        if (leftColumn) resizeObserver.observe(leftColumn)
        if (rightColumn) resizeObserver.observe(rightColumn)
        observers.set(wrapper, resizeObserver)
      }

      scheduleUpdate(wrapper)
    })
  }

  function initPage() {
    initAdaptiveSticky(document)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage)
  } else {
    initPage()
  }

  window.addEventListener('load', initPage)
  window.addEventListener('resize', initPage)
  document.addEventListener('shopify:section:load', function (event) {
    initAdaptiveSticky(event.target)
  })
})()
